/// <reference types="@angular/localize" />

import * as Sentry from '@sentry/angular'
import { environment } from './environments/environment'
import { bootstrapApplication } from '@angular/platform-browser'
import { AppComponent } from './app/app.component'
import { PreloadAllModules, provideRouter, Router, withDebugTracing, withPreloading } from '@angular/router'
import { APP_ROUTES } from './app/app.routes'
import { provideAnimations } from '@angular/platform-browser/animations'
import { ErrorHandler, inject, provideAppInitializer } from '@angular/core'
import { AppInitService } from './app/core/services/app-init.service'
import { provideAuth0 } from '@auth0/auth0-angular'
import { CommonModule, DOCUMENT } from '@angular/common'
import { LIGHTBOX_CONFIG, LightboxConfig } from 'ng-gallery/lightbox'
import { GALLERY_CONFIG, GalleryConfig } from 'ng-gallery'
import { provideNgxMask } from 'ngx-mask'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { initializeApp, provideFirebaseApp } from '@angular/fire/app'
import { getFirestore, provideFirestore } from '@angular/fire/firestore'
import { register } from 'swiper/element/bundle'

Sentry.init({
  dsn: 'https://8ac8ce435fe0ab0ecac7f42f17e4f476@o1157537.ingest.sentry.io/4506435130163200',
  environment: environment.sentry.environment,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/\w{3,5}\.webshop\.(beta\.|develop\.|stage\.)?rouseservices\.com\/api/,
  ],
  // Performance Monitoring
  tracesSampleRate: environment.sentry.traceSampleRate,
  // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

// register Swiper globally
register()

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(APP_ROUTES,
      withPreloading(PreloadAllModules),
      // withDebugTracing(), // uncomment if you want to see the router events in the console
    ),
    provideAnimations(),
    provideAppInitializer(() => {
      inject(Sentry.TraceService)
      inject(AppInitService).init()
    }),
    provideAuth0({
      ...environment.auth,
    }),
    {
      provide: Window,
      useValue: window
    },
    {
      provide: DOCUMENT,
      useValue: document,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: LIGHTBOX_CONFIG,
      useValue: {
        keyboardShortcuts: true,
        exitAnimationTime: 250
      } as LightboxConfig
    },
    {
      provide: GALLERY_CONFIG,
      useValue: {
        autoHeight: true,
        imageSize: 'cover'
      } as GalleryConfig
    },
    provideNgxMask(),
    provideHttpClient(withInterceptorsFromDi()),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideFirestore(() => getFirestore()),
    CommonModule,
  ]
}).catch((err) => console.error(err))
